var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape7 = function SvgShape7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.902 39.337c10.406-52.309-24.197-52.309-13.79 0C56.704-12.972 24.733.267 54.365 44.615 24.734.268.268 24.734 44.616 54.365c-44.348-29.631-57.588 2.34-5.279 12.74-52.309-10.407-52.309 24.197 0 13.79-52.309 10.407-39.063 42.371 5.278 12.74-44.34 29.631-19.875 54.097 9.75 9.75-29.631 44.341 2.34 57.581 12.74 5.278-10.407 52.309 24.197 52.309 13.79 0 10.407 52.309 42.371 39.063 12.74-5.278 29.631 44.341 54.097 19.875 9.75-9.75 44.341 29.631 57.581-2.34 5.278-12.74 52.309 10.407 52.309-24.197 0-13.79 52.309-10.407 39.063-42.371-5.278-12.74 44.341-29.631 19.875-54.097-9.75-9.75 29.631-44.34-2.34-57.58-12.74-5.278z",
    opacity: 0.1
  })));
};
export default SvgShape7;